import { z } from 'zod';

export const POSITION_PRODUCT_STATUS_SCHEMA = z.enum(['DRAFT', 'SUBMITTED']);
export type POSITION_PRODUCT_STATUS = z.infer<typeof POSITION_PRODUCT_STATUS_SCHEMA>;
